<!-- Main Menu -->
<div class="iconnav">
  <div class="container px-0">
    <div class="row no-gutters">
      <div class="column-12 mx-auto column-desktop-8">
        <div class="row no-gutters">
          @for (link of links; track link) {
            @if (link) {
              <div class="column">
                @if (!link.url) {
                  <a class="iconnav-link" role="button" data-modal-toggle="#modal-menu-1">
                    <!-- open sub menu -->
                    <span class="iconnav-icon {{ link.icon }}"></span>
                    <span class="iconnav-label">{{ link.text }}</span>
                  </a>
                }
                @if (link.url && link.url[0] === '/') {
                  <a class="iconnav-link" [routerLink]="link.url"
                    routerLinkActive="is-active" [appTrackingNav]="link.trackingLabel">
                    <!-- navigate to route -->
                    <span class="iconnav-icon {{ link.icon }}"></span>
                    <span class="iconnav-label">{{ link.text }}</span>
                  </a>
                }
                @if (link.url && link.url[0] !== '/') {
                  <a class="iconnav-link" [href]="link.url"
                    [appTrackingNav]="link.trackingLabel">
                    <!-- navigate to url -->
                    <span class="iconnav-icon {{ link.icon }}"></span>
                    <span class="iconnav-label">{{ link.text }}</span>
                  </a>
                }
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>
